<template>
  <v-container>
    <v-row justify="center" class="footer-section">
      <!-- Register Section -->
      <v-col cols="12" sm="12" md="6" class="footer-column text-center">
        <v-card elevation="3" class="pa-4">
          <v-card elevation="12" class="mb-5 d-flex justify-center align-center">
            <h2 class="mb-4" >Register</h2>

          </v-card>
          <v-form ref="registerForm" v-model="valid" lazy-validation>
            <v-text-field
              v-model="form.email"
              label="Email"
              type="email"
              :rules="[rules.required, rules.email]"
              variant="outlined"       
              prepend-icon="mdi-email"                                                                                                                                                                                                                                                                                                                              
              dense
            ></v-text-field>
            <!-- Password Field -->
            <v-text-field
              v-model="form.password"
              label="Password"
              :type="showPassword ? 'text' : 'password'"
              :rules="[rules.required, rules.minLength(6)]"
              variant="outlined"
              dense
              prepend-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>

            <!-- Confirm Password Field -->
            <v-text-field
              v-model="form.confirmPassword"
              label="Confirm Password"
              :type="showPassword ? 'text' : 'password'"
              :rules="[rules.required, matchPassword]"
              variant="outlined"
              dense
              prepend-icon="mdi-lock-check"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="togglePasswordVisibility"
            ></v-text-field>
            <v-btn                                                                                                                                          
              :disabled="!valid"
              class="mt-4"
              color="primary"
              block
              @click="submitRegister"
            >
              Register
            </v-btn>
          </v-form>
          <div class="mt-4">
            <span>Already have an account?</span>
            <a href="/login" class="login-link">Login</a>
          </div>
        </v-card>
      </v-col>
    </v-row>


      <!-- Snackbar for Notifications -->
      <v-snackbar
      v-model="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      valid: false,
      form: {
        email: "",
        password: "",
        confirmPassword: "",
      },
      showPassword: false,
      showConfirmPassword: false,
      snackbar: {
        visible: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
      rules: {
        required: (v) => !!v || "This field is required",
        email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        minLength: (length) => (v) =>
          (v || "").length >= length ||
          `Must be at least ${length} characters long`,
      },
    };
  },
  methods: {
    matchPassword(value) {
      return (
        value === this.form.password || "Passwords must match"
      );
    },

    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPasswordVisibility() {
      this.showConfirmPassword =!this.showConfirmPassword;
    },
    async submitRegister() {
      if (this.$refs.registerForm.validate()) {
        try {
          const response = await axios.post(
            "/alumni/register",
            this.form
          );

          // Show success message
          this.showSnackbar(
            "Registration successful! Redirecting to login...",
            "success"
          );
          // Redirect to login after 3 seconds
          setTimeout(() => {
            this.$router.push("/login"); // Use Vue Router for navigation
          }, 3000);
        } catch (error) {
          console.error("Registration error:", error.response?.data || error);
          // Show error message
          this.showSnackbar(
            error.response?.data?.message || "Registration failed, Please check your connection and try again!",
            "error"
          );
        }
      }
    },
    showSnackbar(message, color) {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
  },
};
</script>



<style scoped>
/* General Footer Styles */
.custom-footer {
background: linear-gradient(45deg, rgb(255, 6, 18) 0%, #390100 100%);
color: #15f6eb;
padding: 100px 0;
border-top: 15px solid #03a9f4;
position: relative;
overflow: hidden;
box-shadow: 0 25px 80px rgba(0, 0, 0, 0.5);
border-radius: 30px 30px 0 0;
z-index: 2;
font-family: 'Roboto', sans-serif;
}

.footer-section {
margin-bottom: 10px;
z-index: 3;
}

.footer-column {
margin-top: 100px;
padding: 40px;
background-color:#eaf1f6;
transition: transform 0.5s ease, box-shadow 0.5s ease, filter 0.5s ease;
cursor: pointer;
z-index: 3;
}
.footer-columnm {
padding: 40px;
transition: transform 0.5s ease, box-shadow 0.5s ease, filter 0.5s ease;
cursor: pointer;
z-index: 3;
}
.footer-columnm:hover {
transform: translateY(-12px); /* Smooth elevation on hover */
box-shadow: 0 35px 80px rgb(8, 82, 131); /* More prominent shadow effect */
filter: brightness(1.2); /* Slight brightness increase */
border-top-left-radius: 100px;
border-bottom-right-radius: 100px;
}
.footer-column:hover {
transform: translateY(-12px); /* Smooth elevation on hover */
box-shadow: 0 35px 80px rgb(8, 82, 131); /* More prominent shadow effect */
filter: brightness(1.2); /* Slight brightness increase */
border-top-left-radius: 100px;
border-bottom-right-radius: 100px;
}

.footer-heading {
font-family: 'Roboto', sans-serif;
font-size: 2rem;
font-weight: 700;
color: #ff0808;
margin-bottom: 20px;
text-transform: uppercase;
text-shadow: 0 0 8px rgb(0, 110, 255);
transition: color 0.3s ease, letter-spacing 0.3s ease;
}
.footer-headingg {
font-family: 'Roboto', sans-serif;
font-size: 3rem;
font-weight: 700;
color: #ff0606;
margin-bottom: 20px;
text-transform: uppercase;
text-shadow: 0 0 8px rgb(0, 115, 255);
transition: color 0.3s ease, letter-spacing 0.3s ease;
}
.footer-heading:hover {
color: #e00b0b;
letter-spacing: 3px;
text-shadow: 0 0 20px rgba(8, 64, 90, 0.9);
}
.footer-headingg:hover {
color: #ffffff;
letter-spacing: 3px;
text-shadow: 0 0 20px rgba(8, 64, 90, 0.9);
}
.footer-text {
font-size: 1.4rem;
color: #9d0606;
margin-bottom: 18px;
line-height: 1.8;
font-weight: 500;
letter-spacing: 0.5px;
transition: opacity 0.3s ease;
}

.footer-text:hover {
opacity: 0.85;
}

.footer-links {
list-style: none;
padding: 0;
margin: 0;
}

.footer-links li {
margin-bottom: 18px;
}

.footer-links a {
color: #d40b0b;
text-decoration: none;
font-weight: 600;
transition: color 0.3s ease, transform 0.3s ease;
font-size: 1.3rem;
}

.footer-links a:hover {
color: #f40303;
transform: scale(1.1);
}

.social-icons {
margin-top: 60px;
display: flex;
justify-content: center;
}

.social-icon {
color: #118ecd;
margin: 0 18px;
transition: transform 0.4s ease, color 0.4s ease, box-shadow 0.4s ease;
font-size: 3rem;
cursor: pointer;
}

.social-icon:hover {
transform: scale(1.4);
color: #03a9f4;
box-shadow: 0 0 25px rgba(0, 169, 244, 0.5);
}

.footer-bottom {
font-size: 1.5rem;
color: #ddd;
text-transform: uppercase;
letter-spacing: 2px;
font-weight: 400;
opacity: 0.9;
transition: opacity 0.3s ease, letter-spacing 0.3s ease;
}

.footer-bottom:hover {
opacity: 1;
letter-spacing: 5px;
}

/* Curved Background Styling */
.footer-curve {
position: absolute;
top: 0px;
left: 0;
right: 0;
height: 200px;
background: #7b0303;
z-index: 1;
border-radius: 50% 50% 0 0;
box-shadow: 0 25px 50px rgba(4, 58, 120, 0.825);
transform: scaleY(-1);
animation: curveAnimation 9s ease-in-out infinite;
}

/* Animated Background */
@keyframes curveAnimation {
0% {
transform: scaleY(1);
}
50% {
transform: scaleY(0.5);
}
100% {
transform: scaleY(1);
}
}

/* Responsive Adjustments */
@media (max-width: 600px) {
.footer-heading {
font-size: 2.5rem;
}

.footer-text {
font-size: 1.1rem;
}

.footer-curve {
height: 250px;
top: -180px;
}

.social-icon {
font-size: 2.5rem;
}
}

/* Circular counter styling */
.circular-counter {
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 10px;
}

.counter-wrapper {
position: relative;
width: 120px;
height: 120px;
border-radius: 50%;
background: linear-gradient(135deg, #ff0000, #5d0404);
display: flex;
justify-content: center;
align-items: center;
box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
animation: popIn 0.6s ease-out;
}

.animated-number {
font-size: 2.5rem;
font-weight: bold;
color: white;
text-align: center;
animation: scaleBounce 1.2s infinite ease-in-out;
}

/* Scale bounce animation for the number */
@keyframes scaleBounce {
0%,
100% {
transform: scale(1);
}
50% {
transform: scale(1.2);
}
}

/* Pop-in effect for the circular counter */
@keyframes popIn {
0% {
transform: scale(0);
opacity: 0;
}
100% {
transform: scale(1);
opacity: 1;
}
}

/* Add a subtle bounce to the entire circle */
.animated-bounce {
animation: bounceEffect 1.5s infinite;
}

@keyframes bounceEffect {
0%, 100% {
transform: translateY(0);
}
50% {
transform: translateY(-10px);
}
}

/* General Styling */
.footer-container {
  padding: 2.5rem;
  /* background: linear-gradient(135deg, #e3f2fd, #bbdefb); */
  /* border-radius: 5px; */
  /* box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.2); */
  max-width: 1000px;
  margin: auto;
  overflow: hidden;
}

/* Heading Styles */
.footer-heading {
  font-family: 'Poppins', sans-serif;
  font-size: 2.5rem;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(90deg, #ff8a65, #d32f2f);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 2rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.highlight {
  color: #d32f2f;
  font-weight: bold;
  font-family:'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
}

.emphasis {
  font-style: italic;
  font-weight: bold;
  color: #5385b7;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
}

/* Card Styles */
.footer-card {
  margin: 1rem 0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /* background: #fff; */
  /* box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1); */
  background: linear-gradient(135deg, #e3f2fd, #bbdefb);
  /* border-top-radius: 25px; */
  border-top-left-radius: 55px;
  border-bottom-right-radius: 55px;

  box-shadow: 0px 10px 30px rgba(17, 173, 201, 0.907);
}

.footer-card:hover {
  transform: translateY(-5px);
  box-shadow: 0px 6px 25px rgba(0, 0, 0, 0.15);
}

.footer-text {
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;
  color: #424242;
  line-height: 1.8;
  padding: 1.5rem;
}

.confidential {
  color: #d32f2f;
  font-weight: bold;
  text-decoration: underline;
}

/* Register Button Section */
.footer-action {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2.5rem;
  background: linear-gradient(90deg, #da465a, #8f060f);
  color: #fff;
  padding: 1rem 2rem;
  border-radius: 25px;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.3s ease;
  text-transform: uppercase;
  font-weight: bold;
}

.footer-action:hover {
  background: linear-gradient(90deg, #dc7979, #d21932);
  transform: scale(1.05);
}

.social-icon {
  color: #ffffff;
  margin-right: 0.8rem;
  animation: bounce 1.5s infinite;
}

/* Bouncing Icon Animation */
@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* Register Text */
.register-text {
  font-family: 'Poppins', sans-serif;
  font-size: 1.2rem;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.2);
}

/* Responsive Design */
@media (max-width: 600px) {
  .footer-container {
    padding: 1.5rem;
  }

  .footer-heading {
    font-size: 1.8rem;
  }

  .footer-text {
    font-size: 0.9rem;
  }

  .register-text {
    font-size: 1rem;
  }
}
</style>
